import Desktop from ".";
import { historyOnlyGames, isBetClosed, isHistoryOnlyGame, roadmapOnlyGames } from "@/modules/commonMobile";
import { onlyUnique } from "@/modules/arrays";
import { emitGameDisconnect } from "@/modules/sockets";

/**
 * Remove win for 1 game only, use window.setTimeout on loadNewValue to avoid conflict.
 * @param pcode The game pcode to remove its game.win.
 */
function removeWin(this: Desktop, pcode: string) {
	const { games } = this.state;
	delete games[pcode].win;
	games[pcode].historyBlink = false;
	this.setState({ games }); // removeWin(pcode)
}

// 
/**
 * Removes win of all games (old function).
 */
function removeWins(this: Desktop) {
	const { games } = this.state;
	
	for (const a in games) {
		delete games[a].win;
		games[a].historyBlink = false;
	}

	this.setState({ games }); // removeWins
}


// {pcode: string}
function closeGame(this: Desktop, e: any) {
	const pcode = e.pcode || e.currentTarget.getAttribute("game");
	const { games, userdata } = this.state;

	let { activeGamePcodes } = this.state;
	activeGamePcodes = activeGamePcodes.filter(item =>
		item !== pcode
	).filter(onlyUnique);

	this.renderGame({ pcode });

	if (games[pcode].isGameConnected)
		emitGameDisconnect(this, userdata, games[pcode]);

	this.setState({
		activeGamePcodes: activeGamePcodes,
		games
	}, function () {
		this.restoreGames();
	});
}

/**
 * Go to operator's lobby
 */
function goToOperatorLobby(this: Desktop){
	const { userdata } = this.state;
	console.log(userdata.user.lobbyUrl);
	
	window.location.href = userdata.user.lobbyUrl;
}

/**
 * Close all games and reset all game features
 */
function closeAllGames(this: Desktop) {
	const {
		games,
		userdata,
		showLobbyRoadmap,
		showLobbyHistory
	} = this.state;

	for (const pcode in games) {
		const game = games[pcode];

		// Disconnect from the server's Socket session
		if (game.active && game.isGameConnected)
			emitGameDisconnect(this, userdata, game);

		game.active = false;
		game.maximised = false;

		game.lobbyRoadmap = showLobbyRoadmap;
		game.alwaysShowRoadmapText = false;
		game.lobbyHistory = showLobbyHistory;
		game.lobbyStatistics = false;
		game.lobbyMinMax = false;

		if (isHistoryOnlyGame(pcode))
			game.lobbyHistory = true;

		if (roadmapOnlyGames.includes(pcode))
			game.lobbyRoadmap = true;
	}

	this.setState({
		activeGameCount: 0,
		showSettingsPopup: false,
		maximisedGamePcode: null,
		games
	});

	return this;
}

function toggleInfoNews(this: Desktop) {
	this.setState({
		showInfoNews: !this.state.showInfoNews,
		showResultHistory: false,
		showTransactionHistoryPopup: false,
	});
}

function toggleTooltipSettings(this: Desktop) {
	this.setState({
		showSettingsPopup: !this.state.showSettingsPopup,
	});
}

function togglePopupTransactionHistory(this: Desktop) {
	const lobby = this;

	// Allow refetch transaction prevents 
	if (this.allowRefetchTransaction) {
		this.fetchTransactionHistory(null);
		this.allowRefetchTransaction = false;

		window.setTimeout(() => {
			lobby.allowRefetchTransaction = true;
		}, 3000);
	}

	this.setState({
		showInfoNews: false,
		showResultHistory: false,
		showTransactionHistoryPopup: !this.state.showTransactionHistoryPopup,
	});
}

function togglePopupResultHistory(this: Desktop) {
	let pcode = "";

	if (this.state.maximisedGamePcode)
		// Similar to commonMobile setActiveGame
		pcode = this.state.maximisedGamePcode;
	else {
		// Set last game as the active game
		const games = this.state.games;
		const gameArray = Object.keys(games);
		pcode = gameArray[gameArray.length - 1];
	}

	this.activePcode = pcode;
	this.setState({
		activeGame: this.state.games[pcode]
	}, function () {
		this.fetchResultHistory();
	});

	this.setState({
		showResultHistory: !this.state.showResultHistory,
		showTransactionHistoryPopup: false,
		showInfoNews: false
	});
}

function toggleLobbyRoadmap(this: Desktop, e: React.MouseEvent) {
	const { games } = this.state;
	const pcode = e.currentTarget.getAttribute("pcode");

	if (!pcode) {
		//Toggle all games
		for (const _pcode in games) {
			const game = games[_pcode];
			game.lobbyRoadmap = true;

			game.lobbyHistory = false;
			game.lobbyStatistics = false;

			if (historyOnlyGames.includes(_pcode) ||
				roadmapOnlyGames.includes(_pcode))
				game.lobbyHistory = this.state.showLobbyRoadmap || this.state.showLobbyHistory;
		}

		this.setState({
			showLobbyHistory: false,
			showLobbyRoadmap: true,
			games
		});
	} else {
		const game = games[pcode];

		//Toggle single game
		game.lobbyHistory = false;
		game.alwaysShowRoadmapText = false;
		game.lobbyStatistics = false;
		game.lobbyRoadmap = true;
		game.lobbyMinMax = false;
		this.setState({ games });
	}
}

function toggleLobbyHistory(this: Desktop, e: React.MouseEvent) {
	const { games } = this.state;
	const pcode = e.currentTarget.getAttribute("pcode");

	if (!pcode) {
		//Toggle all games
		for (const _pcode in games) {
			const game = games[_pcode];
			game.lobbyRoadmap = false;
			game.lobbyHistory = true;
			game.lobbyStatistics = true;

			if (historyOnlyGames.includes(_pcode) ||
				roadmapOnlyGames.includes(_pcode))
				game.lobbyRoadmap = this.state.showLobbyHistory || this.state.showLobbyRoadmap;
		}

		this.setState({
			showLobbyHistory: true,
			showLobbyRoadmap: false,
			games: games
		});
	} else {
		const game = games[pcode];

		//Toggle single game
		game.lobbyRoadmap = false;
		game.lobbyHistory = true;
		game.lobbyStatistics = false;
		game.lobbyMinMax = false;

		this.setState({ games });
	}
}

function toggleGameStatistics(this: Desktop, e: React.MouseEvent) {
	const { games } = this.state;
	const pcode = e.currentTarget.getAttribute("pcode");

	games[pcode].lobbyHistory = false;
	games[pcode].lobbyStatistics = true;

	this.setState({ games });
}

function toggleLobbyMinMax(this: Desktop, e: React.MouseEvent) {
	const { games } = this.state;
	const pcode = e.currentTarget.getAttribute("pcode");

	if (!pcode)
		return;

	const game = games[pcode];

	game.lobbyRoadmap = false;
	game.lobbyHistory = false;
	game.lobbyMinMax = !game.lobbyMinMax;

	this.setState({ games });
}

/**
* Game time update per second.
*/
function updateGameTimers(this: Desktop) {
	// Update displayed date/time
	const { userdata } = this.state;

	// Updates UI date
	const date = new Date(userdata.user.dateTime);
	date.setTime(date.getTime() + 1000);
	userdata.user.dateTime = date.toISOString();
	this.setState({ userdata });

	const { games, timers } = this.state;

	if (!games || !timers)
		return;

	for (const pcode in timers) {
		const betClosed = isBetClosed(timers[pcode].time);

		const game = games[pcode];
		const timeObj = timers[pcode];

		if (!betClosed) {
			timeObj.time -= 1;

			if (game) {
				if (game.active && timeObj.time <= 5) {
					this.playCountdownSFX();

					// automatically submits bets on active games
					if (this.state.autoSubmitBet &&
						game.active &&
						game.totalBet > 0) {

						if (!game.disableSubmitBet)
							this.clickSubmit({ pcode: pcode });
						game.disableSubmitBet = true;
					}
				}

				this.checkController(game); // updateGameTimers
			}
		} else {
			// bet closed
			timeObj.time = 0;

			if (game) {
				this.closeTimer(pcode);
				this.checkController(game); // updateGameTimers

				// Plays "no more bets" voice
				if (game.active && !game.hasPlayedCloseBetSFX) {
					this.playCloseBetSFX();
					game.hasPlayedCloseBetSFX = true;
				}
			}
		}
	}

	this.setState({
		timers,
		games
	}); // updateGameTimers
}

export {
	removeWin,
	removeWins,

	closeGame,
	closeAllGames,
	goToOperatorLobby,
	toggleInfoNews,
	toggleTooltipSettings,
	togglePopupTransactionHistory,
	togglePopupResultHistory,

	toggleLobbyRoadmap,
	toggleLobbyHistory,
	toggleGameStatistics,
	toggleLobbyMinMax,

	updateGameTimers
}